module.exports = "/_next/static/images/location-8b1fba6417aa214293f75db480c0e504.svg";